import { NAME_PARENT_COMPONENT } from '@/types/products'

/**
 * Определение наименования шаблона для карточки товара
 * @param pageName - наименование страницы
 */
export const defineLayoutOfProduct = (pageName: string) => {
  return <Type>(propValue: Type | undefined): undefined | Type => {
    if (NAME_PARENT_COMPONENT.PAGE !== pageName) {
      return
    }

    return propValue
  }
}
